import isInViewport from './viewport';

export default function initCounters() {
    const leftCounter = document.querySelectorAll('.leftCounter');
    const middleCounter = document.querySelectorAll('.middleCounter');
    const bigSpeed = 1000; // The lower the slower

    const rightCounter = document.querySelectorAll('.rightCounter');
    const smallSpeed = 275; // The lower the slower

    const $animateCounterLeft = $('[counter-left]');
    const $animateCounterMiddle = $('[counter-middle]');
    const $animateCounterRight = $('[counter-right]');

    var leftCounterActivated = false;
    var middleCounterActivated = false;
    var rightCounterActivated = false;

    function numberWithSeparators(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function activateCounters(counters, speed) {
        counters.forEach((counter) => {
            const updateCount = () => {
                const target = +counter.getAttribute('data-target');
                const count = +counter.getAttribute('data-browse');

                // Lower inc to slow and higher to slow
                const inc = target / speed;

                // Check if target is reached
                if (count < target) {
                    // Add inc to count and output in counter
                    counter.innerText = numberWithSeparators(count + inc);
                    counter.setAttribute('data-browse', count + inc);
                    // Call function every ms
                    setTimeout(updateCount, 1);
                } else {
                    counter.innerText = numberWithSeparators(target);
                }
            };

            updateCount();
        });
    }

    if ($animateCounterLeft.isOnScreen()) {
        leftCounterActivated = true;
        activateCounters(leftCounter, bigSpeed);
    }
    if ($animateCounterRight.isOnScreen()) {
        rightCounterActivated = true;
        activateCounters(rightCounter, smallSpeed);
    }
    if ($animateCounterMiddle.isOnScreen()) {
        middleCounterActivated = true;
        activateCounters(middleCounter, bigSpeed);
    }
    $(window).scroll(() => {
        if ($animateCounterLeft.isOnScreen() && leftCounterActivated == false) {
            leftCounterActivated = true;
            activateCounters(leftCounter, bigSpeed);
        }
        if ($animateCounterRight.isOnScreen() && rightCounterActivated == false) {
            rightCounterActivated = true;
            activateCounters(rightCounter, smallSpeed);
        }
        if ($animateCounterMiddle.isOnScreen() && middleCounterActivated == false) {
            middleCounterActivated = true;
            activateCounters(middleCounter, bigSpeed);
        }
    });
}
